import IAuthProvider from './IAuthProvider';
import TokenResult from './tokenResult';
import * as microsoftTeams from '@microsoft/teams-js';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

export class MicrosoftTeamsProvider implements IAuthProvider {
  constructor(private httpClient: HttpClient) {}

  async login(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async logout(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async renewTokensAsync(): Promise<TokenResult> {
    this.initializeTeams();
    const tempToken = await this.getAuthTokenAsync();
    return this.exchangeTokenAsync(tempToken);
  }

  async resetPasswordAsync(email: string): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async handleAuthenticationResult(callback: (result: TokenResult, error: any) => void): Promise<void> {
    try {
      this.initializeTeams();
      const token = await this.getAuthTokenAsync();
      const accessToken = await this.exchangeTokenAsync(token);
      callback(accessToken, null);
    } catch (error) {
      callback(null as any, error);
    }
  }

  private initializeTeams(): void {
    microsoftTeams.initialize();
  }

  private getAuthTokenAsync(): Promise<string> {
    return new Promise((resolve, reject) => {
      microsoftTeams.authentication.getAuthToken({
        successCallback: (token: string) => resolve(token),
        failureCallback: (error: string) => reject(new Error(error))
      });
    });
  }

  private async exchangeTokenAsync(token: string): Promise<TokenResult> {
    const headers = new HttpHeaders().set('Accept', 'application/json').set('Authorization', 'Bearer ' + token);
    const response = await this.httpClient
      .post<AadToken>(
        environment.apiServiceUrl + '/api/token/exchange',
        {},
        {
          headers: headers
        }
      )
      .toPromise();

    return {
      accessToken: response.access_token,
      idToken: response.id_token,
      expiresIn: response.expires_in,
      scope: response.scope,
      tokenType: response.token_type
    };
  }
}

class AadToken {
  access_token!: string;
  id_token!: string;
  expires_in!: number;
  scope!: string;
  token_type!: string;
}
